import React, {
  useState,
  useEffect
} from 'react';

import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import {
  Divider,
  Button,
  IconButton,
  Paper,
  Typography,
  Collapse,
  ListSubheader,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import {
  Thesis,
} from '../../../types';
import localization from '../../../utils/localizations';
import {ThesisConsultationHistory} from '../collections';
import {ThesisConsultationForm} from '../forms';


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
  },
  secondPanel: {
    padding: 10,
    marginTop: 20,
    marginBottom: 20,
  },
  pageTitle: {
    marginTop: 10,
    marginBottom: 10,
  },
  paddingTopBottom: {
    paddingTop: 10,
    paddingBottom: 10,
  },
}));
 

function ThesisConsultations(props: {
  thesis: Thesis;
  onAdded?: () => void;
  readOnly?: boolean;
}) {
  const classes = useStyles();
  const [showForm, setShowForm] = useState(false);
  const consultations = props.thesis.consultations;
  let currentData = undefined;
  let editDisabled = false;
  if (props?.thesis?.id) {
    currentData = {
      thesis: props.thesis.id,
      content: '',
      advisor: props.thesis.primary_advisor ? props.thesis.primary_advisor.id : undefined,
    }
    if ((props.thesis.status == 'completed') || (props.thesis.status == 'closed')) {
      editDisabled = true;
    }
  }

  if (props.readOnly) editDisabled = props.readOnly;

  return (
    <Paper className={classes.secondPanel}>
      <ListSubheader style={{paddingLeft: 8}}>{localization.thesisConsultationsHistory}</ListSubheader>
      
      <ThesisConsultationHistory
        consultations={props.thesis.consultations}
        onRemoved={(id: string) => {
          if (props.onAdded) props.onAdded();
        }}
      />


      <Collapse
        in={!showForm}
      >
        <div className={classes.paddingTopBottom}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon/>}
            disabled={editDisabled}
            onClick={() => setShowForm(true)}
          >{localization.addNewEntry}</Button>
        </div>
      </Collapse>

      <Collapse
        in={showForm}
        {...(showForm ? { timeout: 1000 } : {})}
      >
        <ThesisConsultationForm
          onSubmitted={() => {
            setShowForm(false);
            if (props.onAdded) props.onAdded();
          }}
          onCancelled={() => {
            setShowForm(false);
          }}
          values={currentData}
        />
      </Collapse>
    </Paper>
  );
}

export {ThesisConsultations};
